import React from "react";
import Select from "react-select";
import Radium from "radium";
import EventListener from "react-event-listener";

import {
  RaisedButton,
  Checkbox,
  RadioButton,
  RadioButtonGroup,
  Toggle
} from "material-ui";

import connectToStores from "alt-utils/lib/connectToStores";
import EventBucketStore from "../stores/EventBucketStore";
import EventBucketActions from "../actions/EventBucketActions";
import LedgerActions from "../actions/LedgerActions";
import FilmActions from "../actions/FilmActions";
import LedgerStore from "../stores/LedgerStore";
import UserStore from "../stores/UserStore";
import FilmStore from "../stores/FilmStore";

import ReportsHeader from "./partials/reports-header.jsx";
import WorkingIndicator from "./partials/working-indicator.jsx";
import Label from "./partials/label.jsx";
import BoxOfficeReportView from "./partials/report-views/box-office-report-view.jsx";

import { DateRangePicker } from "react-date-range";
import {
  defaultStaticRanges,
  createStaticRanges
} from "react-date-range/dist/defaultRanges";

import moment from "moment";
import twix from "twix";

import * as util from "../util";
import config from "../config";

class LedgerBoxOfficeReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showRangeEditor: false,
      allTime: true,
      range: {
        key: "selection",
        startDate: moment().subtract(1, "month"),
        endDate: moment()
      },
      selectedFilm: null,
      selectedBucket: null
    };

    this.onWindowClick = this.onWindowClick.bind(this);
    this.onWindowKeyDown = this.onWindowKeyDown.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.formatFilms = this.formatFilms.bind(this);
    this.downloadCsv = this.downloadCsv.bind(this);
    this.downloadPdf = this.downloadPdf.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  static getStores() {
    return [EventBucketStore, FilmStore, LedgerStore];
  }

  static getPropsFromStores() {
    return {
      getEventBuckets: EventBucketStore.getEventBuckets,
      getEventBucketById: EventBucketStore.getEventBucketById,
      getLedgerAnalyticsTransactions:
        LedgerStore.getLedgerAnalyticsTransactions,
      getLedgerBoxOfficeTransactions:
        LedgerStore.getLedgerBoxOfficeTransactions,
      getLedgerBoxOfficeReport: LedgerStore.getLedgerBoxOfficeReport,
      isFetching: LedgerStore.getState().isFetching,
      getAllUserFilms: FilmStore.getAllUserFilms
    };
  }

  onWindowClick(e) {
    if (
      this.state.showRangeEditor &&
      (!this.container ||
        (!this.container.contains(e.target) &&
          !this.rangeButton.contains(e.target)))
    ) {
      this.setState({ showRangeEditor: false });
    }
  }

  onWindowKeyDown(e) {
    if (this.state.showRangeEditor && e.which === 27) {
      // esc
      this.setState({ showRangeEditor: false });
    }
  }

  handleDateChange({ selection }) {
    if (selection.startDate === "all_time") {
      this.setState(
        { allTime: true, showRangeEditor: false, range: this.state.range },
        () => {
          this.componentWillReceiveProps(this.props, true);
        }
      );
      return;
    }

    console.log(selection);

    this.setState({ range: selection, allTime: false }, () => {
      this.componentWillReceiveProps(this.props, true);
    });
  }

  componentDidMount() {
    EventBucketActions.fetchAll.defer();
    FilmActions.fetchAllForUser.defer();
    this.componentWillReceiveProps(this.props, true);
  }

  componentWillReceiveProps(newProps, force = false) {
    if (force === true) {
      if (newProps.params.eventBucketId !== this.props.params.eventBucketId) {
        EventBucketActions.fetchOne.defer(newProps.params.eventBucketId);
      }
    }
  }

  formatFilms() {
    const allFilms = this.props.getAllUserFilms();
    const films = allFilms.reduce(
      function (filmArray, item) {
        if (item.name !== "" && item.name !== undefined) {
          if (this.state.selectedBucket === item.event_bucket) {
            filmArray.push({ value: item.id, label: item.name });
          }
        }
        return filmArray;
      }.bind(this),
      []
    );

    return films;
  }

  downloadCsv() {
    const conditions = this.buildConditions();
    const options = {
      timePeriod: this.state.grouping,
      format: "csv"
    };

    const form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/box_office_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedCsv";

    document.body.appendChild(form);

    window.open("", "generatedCsv");
    form.submit();
  }

  downloadPdf() {
    const conditions = this.buildConditions();
    const options = {
      timePeriod: this.state.grouping,
      format: "pdf"
    };

    let form = document.createElement("form");
    form.method = "post";
    form.action = `${
      config.endpoint
    }analytics/box_office_report?${UserStore.makeApiKeyQueryString()}&conditions=${JSON.stringify(
      conditions
    )}&options=${JSON.stringify(options)}`;
    form.target = "generatedPdf";

    document.body.appendChild(form);

    window.open("", "generatedPdf");
    form.submit();
  }

  getStyles() {
    return {
      rangeContainer: {
        float: "right",
        marginBottom: "1.25em"
      },
      rangeButton: {
        display: "inline-block",
        borderRadius: 20,
        padding: "8px 16px",
        fontSize: "12pt",
        color: "rgb(33,33,33)",
        cursor: "pointer",
        boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.1)",
        transition: "0.1s ease-in-out",
        ":hover": {
          boxShadow: "0 0 5px 2px rgba(0, 0, 0, 0.2)"
        }
      },
      overlay: {
        position: "absolute",
        right: 0,
        top: 0,
        backgroundColor: "#fff",
        boxShadow: "0 0 5px 2px rgb(0,0,0,0.1)",
        zIndex: 1
      },
      overlaySubmit: {
        position: "absolute",
        right: 10,
        bottom: 10
      },
      gridHeaderRow: {
        color: "#fff",
        backgroundColor: "#0288d1"
      },
      gridHeaderLabel: {
        textAlign: "right",
        padding: "4px",
        width: "100px",
        borderRight: "1px solid #fff"
      },
      gridDayTitle: {
        fontWeight: "bold",
        fontSize: "16px",
        paddingTop: "20px",
        paddingBottom: "2px",
        paddingLeft: "2px"
      },
      gridTimeTitle: {
        fontWeight: "bold",
        fontSize: "13px",
        paddingTop: "2px",
        paddingLeft: "2px",
        paddingBottom: "2px"
      },
      gridLabelCell: {
        textAlign: "left",
        padding: "2px"
      },
      gridDataCell: {
        textAlign: "right",
        padding: "2px",
        width: "100px"
      },
      gridButtonRow: {
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "start"
      }
    };
  }

  render() {
    const styles = this.getStyles(),
      eventBucketId = this.state.selectedBucket,
      selectedFilms = this.state.selectedFilms || [],
      eventBucket = this.props.getEventBucketById(eventBucketId),
      films = this.props.getAllUserFilms();

    return (
      <div>
        <EventListener
          target="window"
          onClick={this.onWindowClick}
          onKeyDown={this.onWindowKeyDown}
        />

        <ReportsHeader
          eventBucket={eventBucket}
          allEventBuckets={this.props.getEventBuckets()}
          label="reports"
          subpath="sales"
          query={this.props.location.query}
          onRefresh={() => this.componentWillReceiveProps(this.props, true)}
          isRefreshing={this.props.isFetching}
          hideHeader={true}
          handleChange={b =>
            this.setState({ selectedBucket: b.value, selectedFilms: [] })
          }
        />

        <div style={{ position: "relative" }}>
          <div
            style={styles.rangeContainer}
            ref={r => {
              this.rangeButton = r;
            }}
          >
            <RaisedButton
              onClick={() => this.setState({ showRangeEditor: true })}
              label={
                this.state.allTime
                  ? "All time sales – click to filter"
                  : `${moment
                      .tz(this.state.range.startDate, eventBucket.timezone)
                      .format("ll")} – ${moment
                      .tz(this.state.range.endDate, eventBucket.timezone)
                      .format("ll")}`
              }
            />
          </div>

          <h1 style={{ lineHeight: 1.2 }}>
            {selectedFilms.length > 0
              ? selectedFilms.length === 1
                ? selectedFilms[0].label + " - "
                : "Multiple Films "
              : "Generate "}
            Box Office Report
          </h1>

          <div style={{ float: "left", width: 400 }}>
            <Select
              options={this.formatFilms().map(b => ({
                label: b.label,
                value: b.value
              }))}
              value={selectedFilms}
              clearable={false}
              multi
              onChange={e => {
                this.setState({ selectedFilms: e }, () => {
                  this.componentWillReceiveProps(this.props, true);
                });
              }}
            />
          </div>

          {this.state.showRangeEditor ? (
            <div
              style={styles.overlay}
              ref={r => {
                this.container = r;
              }}
            >
              <DateRangePicker
                ranges={[this.state.range]}
                onChange={this.handleDateChange}
                maxDate={new Date()}
                staticRanges={[
                  {
                    label: "All Time",
                    isSelected: () => false,
                    range: () => {
                      return {
                        startDate: "all_time",
                        endDate: "all_time"
                      };
                    }
                  }
                ].concat(defaultStaticRanges)}
              />
              <div style={styles.overlaySubmit}>
                <RaisedButton
                  label="Close"
                  onTouchTap={() => this.setState({ showRangeEditor: false })}
                />
              </div>
            </div>
          ) : null}

          {!this.props.isFetching ? (
            <BoxOfficeReportView
              selectedBucket={eventBucketId}
              selectedFilms={selectedFilms}
              allTime={this.state.allTime}
              startTime={this.state.range.startDate}
              endTime={this.state.range.endDate}
              grouping={this.state.grouping}
            />
          ) : (
            <div style={{ clear: "both" }}>
              <WorkingIndicator fullPage={true} />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default Radium(connectToStores(LedgerBoxOfficeReport));



// WEBPACK FOOTER //
// ./src/app/components/ledger-box-office-report.jsx